import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  row: {
    width: '100%',
    padding: [theme.spacing(1), theme.spacing(3)],
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
    },
  },
  labelBox: {
    [theme.breakpoints.up('mobile')]: {
      width: '60%',
    },
  },
  valueBox: {
    [theme.breakpoints.up('mobile')]: {
      width: '40%',
    },
  },
  highlited: {
    backgroundColor: theme.palette.colors.foam,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/components/SurveySummary/components/InfoRow/useStyles.js